import React, { useEffect } from 'react'
import { useCountdown } from './hooks/useCountDown'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAppDispatch } from '../../store/hooks'
import { logout } from '../../store/auth/authSlice'

const ExpiredNotice: React.FC = () => {
  return (
    <div className='expired-notice'>
      <span>Your ghost session expired!!!</span>
    </div>
  )
}
type DataTimeDisplayProps = {
  value: number
  type: string
  isDanger: boolean
}
export const DateTimeDisplay: React.FC<DataTimeDisplayProps> = ({ value, type, isDanger }) => {
  return <>{value.toString().length === 1 ? `0${value}` : value}</>
}

type ShowCounterProps = {
  days: number
  hours: number
  minutes: number
  seconds: number
}
const ShowCounter: React.FC<ShowCounterProps> = ({ days, hours, minutes, seconds }) => {
  return (
    <div className='show-counter d-flex justify-content-center align-items-center'>
      {days > 0 && (
        <>
          <DateTimeDisplay value={days} type={'Days'} isDanger={days <= 3} /> <>:</>
        </>
      )}
      {hours > 0 && (
        <>
          <DateTimeDisplay value={hours} type={'Hours'} isDanger={false} />
          <>:</>
        </>
      )}
      <DateTimeDisplay value={minutes} type={'Mins'} isDanger={minutes <= 3} />:<DateTimeDisplay value={seconds} type={'Seconds'} isDanger={minutes <= 3} />{' '}
      minutes left
    </div>
  )
}

type CountdownTimerProps = {
  targetDate: number
}

export const CountdownTimer: React.FC<CountdownTimerProps> = ({ targetDate }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useAppDispatch()

  const [days, hours, minutes, seconds] = useCountdown(targetDate)
  useEffect(() => {
    if (days + hours + minutes + seconds <= -5) {
      dispatch(logout(location))
      navigate('/')
    }
  }, [days, hours, minutes, seconds])
  if (days + hours + minutes + seconds <= 0) {
    return <ExpiredNotice />
  } else {
    return <ShowCounter days={days} hours={hours} minutes={minutes} seconds={seconds} />
  }
}
